export interface IUserShopAccessRequest {
  firstName?: string
  lastName?: string
  emailAddress?: string
  userId?: string
  shopIds?: string[]
}
